import { lazy, useCallback } from 'react';

import { useStores } from '../stores/useStores';

const PurchaseLimitExceeded = lazy(() => import('../features/payments/PurchaseLimitExceeded'));

export const usePurchaseLimit = (): VoidFunction => {
  const { uiStore, portalStore } = useStores();

  return useCallback(
    function onPurchaseLimitExceeded() {
      uiStore.setCloseDialog();
      portalStore.openPortal(PurchaseLimitExceeded);
    },
    [portalStore, uiStore],
  );
};
